document.addEventListener("DOMContentLoaded", () => {
  const panel = document.getElementById("cart");
  const overlay = document.getElementById("overlay");
  const count = document.getElementById("count");
  const items = document.getElementById("items");
  const total = document.getElementById("total");

  const open = () => { panel?.classList.add("open"); overlay?.classList.add("show"); };
  const close = () => { panel?.classList.remove("open"); overlay?.classList.remove("show"); };

  document.getElementById("bagBtn")?.addEventListener("click", open);
  document.getElementById("close")?.addEventListener("click", close);
  overlay?.addEventListener("click", close);

  document.querySelectorAll(".sizes").forEach(g =>
    g.querySelectorAll("button:not([disabled])").forEach(b =>
      b.addEventListener("click", () => {
        g.querySelectorAll("button").forEach(x => x.classList.remove("active"));
        b.classList.add("active");
      })
    )
  );

  async function refresh() {
    const r = await fetch('/cart.js');
    const c = await r.json();
    if (count) count.textContent = c.item_count;
    if (total) total.textContent = Shopify.formatMoney ? Shopify.formatMoney(c.total_price) : ('$' + (c.total_price / 100).toFixed(2));
    if (items) {
      items.innerHTML = c.items.length
        ? c.items.map(x => `<div class="cart-line"><img src="${x.image || ''}" alt=""><div><h3>${x.product_title}</h3><p>${x.variant_title || ''}</p><p>${Shopify.formatMoney ? Shopify.formatMoney(x.final_line_price) : ('$' + (x.final_line_price / 100).toFixed(2))} × ${x.quantity}</p></div></div>`).join('')
        : '<p style="color:#777;font-size:11px">Your bag is empty.</p>';
    }
    return c;
  }

  document.querySelectorAll('[data-add-shopify]').forEach(btn =>
    btn.addEventListener('click', async () => {
      const card = btn.closest('article');
      const active = card.querySelector('.sizes .active');
      const id = active?.dataset.variantId;
      if (!id) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        await refresh();
        open();
      } catch (e) {
        console.error(e);
      } finally {
        btn.disabled = false;
      }
    })
  );

  window.viestaRefreshCart = refresh;
  window.viestaOpenCart = open;

  refresh();
});

/* VIESTA product page: variant selection + add to bag */
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('viesta-order-form');
  if (form) {
    const selected = document.getElementById('selected-variant');

    document.querySelectorAll('.variant-choice').forEach(b => b.addEventListener('click', () => {
      document.querySelectorAll('.variant-choice').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      selected.value = b.dataset.variantId;
    }));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      const variantId = Number(selected.value);
      if (!variantId) { alert('Please choose a size.'); return; }
      const button = form.querySelector('.buy-now');
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      try {
        const add = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!add.ok) throw new Error('Could not add product');
        if (window.viestaRefreshCart) await window.viestaRefreshCart();
        if (window.viestaOpenCart) window.viestaOpenCart();
      } catch (err) {
        console.error(err);
        alert('Something went wrong adding this to your bag. Please try again.');
      } finally {
        if (button) { button.disabled = false; button.textContent = 'Add to bag'; }
      }
    });
  }

  if (!document.cookie.includes('viesta_nonrefundable_ack=1')) {
    const notice = document.createElement('div');
    notice.className = 'cookie-notice';
    notice.innerHTML = '<p><strong>Important:</strong> All VIESTA purchases are non-refundable.</p><button type="button">I understand</button>';
    document.body.appendChild(notice);
    notice.querySelector('button').addEventListener('click', () => {
      document.cookie = 'viesta_nonrefundable_ack=1; max-age=31536000; path=/; SameSite=Lax';
      notice.remove();
    });
  }
});

/* VIESTA checkout-details page: multi-item summary + customer details -> real checkout */
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('viesta-checkout-form');
  if (!form) return;

  const orderSummary = document.getElementById('order-summary');
  const feeEl = document.getElementById('delivery-fee');
  const totalEl = document.getElementById('order-total');
  const emptyNotice = document.getElementById('checkout-empty');
  let cart = null;

  function money(cents) {
    return Shopify.formatMoney ? Shopify.formatMoney(cents) : ('$' + (cents / 100).toFixed(2));
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  }

  function updateTotal() {
    if (!cart) return;
    const opt = document.getElementById('delivery-area')?.selectedOptions[0];
    const fee = opt?.dataset.fee ? Number(opt.dataset.fee) : 0;
    feeEl.textContent = fee ? money(fee * 100) : '—';
    totalEl.textContent = money(cart.total_price + fee * 100);
  }

  function renderSummary() {
    if (!cart || !cart.items.length) {
      form.style.display = 'none';
      if (emptyNotice) emptyNotice.style.display = 'block';
      return;
    }
    orderSummary.querySelectorAll('[data-item-row]').forEach(el => el.remove());
    const rowsHtml = cart.items.map(x =>
      `<div data-item-row><span>${escapeHtml(x.product_title)}${x.variant_title ? ' — ' + escapeHtml(x.variant_title) : ''} × ${x.quantity}</span><strong>${money(x.final_line_price)}</strong></div>`
    ).join('');
    orderSummary.insertAdjacentHTML('afterbegin', rowsHtml);
    updateTotal();
  }

  document.getElementById('delivery-area')?.addEventListener('change', updateTotal);

  fetch('/cart.js').then(r => r.json()).then(c => { cart = c; renderSummary(); });

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const fd = new FormData(form);
    const opt = document.getElementById('delivery-area').selectedOptions[0];
    const fee = opt?.dataset.fee || 0;
    const attrs = {
      'Customer first name': fd.get('first_name'),
      'Customer family name': fd.get('last_name'),
      'Customer phone': fd.get('phone'),
      'Customer email': fd.get('email'),
      'Delivery area': fd.get('delivery_area'),
      'Delivery fee': '$' + fee,
      'Payment method': fd.get('payment_method')
    };
    const button = form.querySelector('.buy-now');
    button.disabled = true;
    button.textContent = 'Preparing checkout…';
    try {
      const upd = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
      if (!upd.ok) throw new Error('Could not save order details');
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Something went wrong. Please try again.');
      button.disabled = false;
      button.textContent = 'Continue to secure checkout';
    }
  });
});